import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.timeout = null

    const input = this.element.querySelector("input")
    if (!input) return

    if (input.value.length > 0) {
      const value = input.value
      input.focus()
      input.setSelectionRange(value.length, value.length)
    }
  }

  submit() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }
}